import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the dashboard menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getDashboardMenu({ businessEntityUuid, order }) {
  return processMenu({
    title: 'Dashboard',
    itemId: 'dashboard',
    icon: 'home-fill.svg',
    path: generatePath(ROUTES.entity, { businessEntityUuid }),
    order
  });
}
